export default "/images/4784e0cb578449e5214eeef5af57ca96.avif";